import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLeaveFullscreen = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "currentColor",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.4 12.4c-.38.39-.9.6-1.44.6H5.73a.73.73 0 1 1 0-1.47h5.23a.57.57 0 0 0 .57-.57V5.73a.73.73 0 0 1 1.47 0v5.23c0 .54-.21 1.06-.6 1.44ZM12.27 27a.73.73 0 0 1-.74-.73v-5.02a.93.93 0 0 0-.2-.6.49.49 0 0 0-.37-.18H5.73a.73.73 0 0 1 0-1.47h5.23c.58 0 1.11.27 1.48.7.37.43.56.99.56 1.55v5.02c0 .4-.33.73-.73.73ZM27 12.27c0 .4-.33.73-.73.73h-5.02a2.4 2.4 0 0 1-1.55-.56c-.43-.37-.7-.9-.7-1.48V5.73a.73.73 0 1 1 1.47 0v5.23c0 .11.05.25.19.37s.35.2.6.2h5c.41 0 .74.33.74.74ZM19.73 27a.73.73 0 0 1-.73-.73v-5.02A2.25 2.25 0 0 1 21.25 19h5.02a.73.73 0 1 1 0 1.47h-5.02a.79.79 0 0 0-.78.79v5c0 .41-.33.74-.74.74Z"
	})
});
export { SvgLeaveFullscreen as ReactComponent };
